import React from 'react';
import * as  commonFunc from './HotAreaMapCommon';
import { Checkbox } from 'antd';
import SvgIcon from 'SvgIcon';

export class ListAreaMap extends React.Component {
  //SearchTree

  getDemoCStyle() {
    // return { "codeField": "code", "stateField": "stop", "captionFields": [{ "field": "code", "prefix": "", "suffix": "元" }, { "field": "name", "prefix": "赠", "suffix": "元" }] }
    return { rowCount: 8, refreshInterval: 5000, extendClassName: "扩展类名_", "codeField": "code", "stateField": "stop", "captionFields": [{ "field": "code", "prefix": "", "suffix": "" }, { "field": "name", "prefix": "", "suffix": "" }] }
  }
  constructor(props) {
    super(props);
    /*   props:
      cStyle: 数据字段的配置文件 { rowCount: 8, bMultiSel: false, refreshInterval: -1, extendClassName: "扩展类名", "codeField": "code", "stateField": "stop", "captionFields": [{ "field": "code", "prefix": "", "suffix": "" }, { "field": "name", "prefix": "", "suffix": "" }] }
      model ： viewModel
      model 外层干预选中的区域： setSelectedAreaArr
      model 选中事件  select
      width: 显示宽度
      height：显示高度
      selectedAreaArr: []选中区域的index列表
      */
    let cStyle = _.isEmpty(props.cStyle) ? this.getDemoCStyle() : props.cStyle;
    cStyle = commonFunc.JSONParse(cStyle);
    console.log("ListAreaMap cStyle = " + JSON.stringify(cStyle))
    let tmpState = {};
    let fieldMapping = {};
    fieldMapping.codeField = cStyle.codeField || "";
    fieldMapping.stateField = cStyle.stateField || "";
    fieldMapping.captionFields = cStyle.captionFields || "";
    if (!fieldMapping.codeField || !fieldMapping.stateField || !fieldMapping.captionFields) {
      console.log("在栏目中未能找到全部的列表区配置字段 codeField stateField captionFields");
    }
    tmpState.fieldMapping = fieldMapping;
    tmpState.rowCount = cStyle.rowCount || 8;
    tmpState.extendClassName = cStyle.hasOwnProperty("extendClassName") ? cStyle.extendClassName : "";
    tmpState.refreshInterval = cStyle.hasOwnProperty("refreshInterval") ? cStyle.refreshInterval : -1;
    tmpState.bNeedRefresh = false;
    if (tmpState.refreshInterval > 1000) {
      tmpState.bNeedRefresh = true;
    }
    else {
      console.log("未设置刷新时间或者设置的刷新时间太短。");
    }

    tmpState.refreshTime = new Date();
    tmpState.selectedAreaArr = props.selectedAreaArr || [];
    tmpState.bMultiSel = cStyle.hasOwnProperty("bMultiSel") ? cStyle.bMultiSel : false;
    tmpState.areaData = [];
    tmpState.width = props.width || 500;
    tmpState.height = props.height || 400;

    this.state = tmpState;
    this.defaultAreaBorder = "solid 2px white";// transparent
    this.areaBackPicUrl_0 = "http://resourceyxy.yonyouup.com/34d44c87-35a8-4469-ae1a-da17a7ad2ae1.png";
    this.areaBackPicUrl_1 = "http://resourceyxy.yonyouup.com/31db3764-33bf-4fac-b156-00982cf96b5e.png";

  }

  componentDidMount() {
    let self = this;
    let model = this.props.model;
    const { meta } = this.props;
    if (model.modelType.toLowerCase() == 'gridmodel')
      this.gridModel = model;
    else
      // this.gridModel = model.getGridModel();
      this.gridModel = model.get(meta.childrenField || meta.cCode);
    this.gridModel && this.gridModel.addListener(this);
    this.gridModel && this.gridModel.on('setSelectedAreaArr', function (arr) { self.setState({ selectedAreaArr: arr }); });
    // this.InitAreaColumns(this.getDemoAreaColumns());
    this.setTimeInterval();

  }


  shouldComponentUpdate(nextProps, nextState) {
    let bFlag = false;
    if ((nextProps.hasOwnProperty("selectedAreaArr")) && (_.isEqual(nextProps.selectedAreaArr, this.state.selectedAreaArr) == false)) {
      this.state.selectedAreaArr = nextProps.selectedAreaArr;
      bFlag = true;
    }
    if ((nextProps.hasOwnProperty("model")) && (!this.gridModel)) {
      this.setGridModel(model);
      bFlag = true;
    }
    if ((nextProps.hasOwnProperty("width")) && nextProps.width && (_.isEqual(nextProps.width, this.state.width) == false)) {
      this.state.width = nextProps.width;
      bFlag = true;
    }
    if ((nextProps.hasOwnProperty("height")) && nextProps.height && (_.isEqual(nextProps.height, this.state.height) == false)) {
      this.state.height = nextProps.height;
      bFlag = true;
    }
    return true;
  }

  setTimeInterval() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.state.bNeedRefresh == true) {
      this.timer = setInterval(() => this.refreshData(), this.state.refreshInterval);
    }
  }

  componentDidUpdate() {
    if (this.gridModel)
      this.gridModel.addListener(this);
  }
  componentWillUnmount() {
    let self = this;
    if (this.gridModel) {
      this.gridModel.removeListener(this);
    }
    this.timer && clearTimeout(this.timer);
  }
  getAreaCaption(width, height, data, captionFields) {
    let captionArr = [];
    data && captionFields && captionFields.forEach((ele, index) => {
      // let caption = _.get(data, ele.field) || "";
      let caption = commonFunc.getDataSourceFieldValue(_.get(data, ele.field), 1);
      if (caption != "") {
        caption = (ele.prefix || "") + caption + (ele.suffix || "");
      }
      captionArr.push(<div style={{
        "textAlign": 'center',
        // "fontWeight": 'bold',
        // "display": "-webkit-box",
        // "-webkit-box-orient": "vertical",
        // "-webkit-line-clamp": "1",
        "whiteSpace": "nowrap",
        "overflow": "hidden",
        "textOverflow": "ellipsis",
      }}
        className={this.getClassName("AreaCaption_" + ele.field) + " " + this.getClassName("AreaCaptionIndex_" + index)}
      >
        {caption}
      </div >
      );
    })
    return <div className={this.getClassName("AreaCaptionList")} >
      {captionArr}
    </div>;
  }
  handleAreaClick(ele, index, disabled) {
    if (disabled) {
      return;
    }
    else {
      let selectedAreaArr = this.state.selectedAreaArr;
      // let codeValue = ele[this.state.fieldMapping.codeField];
      if (this.state.selectedAreaArr.indexOf(index) >= 0) {
        _.remove(selectedAreaArr, function (o) { return index == o; });
        this.gridModel.unselect([index]);
      }
      else {
        if (this.state.bMultiSel) {
          selectedAreaArr.push(index);
        }
        else {
          selectedAreaArr = [index];
        }
        this.gridModel.select(selectedAreaArr);
      }

      // this.setState({ selectedAreaArr })
      // if (this.props.onSelectArea) {
      //   this.props.onSelectArea(bSelected, ele);
      // }
      // cb.utils.alert("你选择/取消的包房  = " + index, 'error');}
    }
  }

  setDataSource = (data) => {
    // data.forEach(
    //   ele => {
    //     ele.areaBackPicUrl = (Math.random() > 0.5 ? this.areaBackPicUrl_0 : this.areaBackPicUrl_1)
    //   }
    // )
    this.setState({ areaData: data, refreshTime: (new Date()) });
  }
  setColumns = (columndata) => {
  }
  setTitle = (titleList) => {
    // this.setState({
    //   titleList
    // });
  }
  setListenerState = (params) => {
    this.setState({ areaData: params.rows, refreshTime: (new Date()) });
  }
  setColumnByTtile = (columns) => {
    // this.columns = columns;
    // let columnset = this.RemodelingColumn(this.dataList, columns);
    // this.setState({ columnset });
  }
  select = (indexes) => {
    this.setState({ selectedAreaArr: indexes });
  }
  unselect = (indexes) => {
    let { selectedAreaArr } = this.state;
    let newArr = [];
    selectedAreaArr.map(index => {
      if (!indexes.indexOf(index)) newArr.push(index);
    });
    this.setState({ selectedAreaArr: newArr })
  }
  getClassName(str) {
    let className = "ListAreaMapDisplay_" + str;
    if (!!this.state.extendClassName) {
      className = className + " " + this.state.extendClassName + "ListAreaMap_" + str
    }
    return className;
  }
  getArea(ele, index) {
    let self = this;
    let style = {};
    let caption = "";
    // style.width = (Math.floor(10000 / this.state.rowCount) / 100) + "%";
    // style.height = (Math.floor(10000 / this.state.rowCount) / 100) + "%";
    style.width = Math.floor(this.state.width / this.state.rowCount);
    style.height = Math.floor(this.state.width / this.state.rowCount);

    style.border = self.defaultAreaBorder;
    style.margin = 0;
    style.padding = 2;
    style.float = "left";
    let tmpMapping = self.state.fieldMapping;
    if (ele.areaBackPicUrl) {
      style.backgroundImage = 'url(' + ele.areaBackPicUrl + ')';
      style.backgroundSize = '100% 100%';
    }
    // let stateFieldValue = _.get(ele, tmpMapping.stateField);
    let stateFieldValue = commonFunc.getDataSourceFieldValue(_.get(ele, tmpMapping.stateField), 2);
    let className = this.getClassName("Area");
    className = className + " " + this.getClassName("AreaState_" + stateFieldValue);
    let bSelected = (this.state.selectedAreaArr.indexOf(index) >= 0);
    if (bSelected)
      className = className + " " + this.getClassName("Area_Selected");

    let areaHtml = undefined;
    let params = this.getAreaBusRender(ele, index);
    if (params.areaHtml) {
      areaHtml = <div
        className={this.getClassName("AreaBusRender")}
        dangerouslySetInnerHTML={{ __html: params.areaHtml }}>
      </div>;
    }
    let disabled = (params.state && params.state.disabled) || false;
    if (disabled) {
      className = className + " " + this.getClassName("AreaState_Disabled");
    }
    let checkBoxHtml;
    if (self.state.bMultiSel == true) {
      checkBoxHtml = <Checkbox
        className={this.getClassName("CheckBox")}
        checked={bSelected}
        disabled={disabled}
      />;
    }

    return <div style={style}
      onClick={() => this.handleAreaClick(ele, index, disabled)}
      className={className}
      title={ele && ele.name}
    >
      {self.getAreaCaption(style.width, style.height, ele, tmpMapping.captionFields)}
      {areaHtml}
      {checkBoxHtml}
    </div>;

  }
  getAreaBusRender(area, rowIndex) {
    let params = { area, rowIndex, selectedAreaArr: this.state.selectedAreaArr, areaHtml: undefined, state: { disabled: false } }
    this.gridModel.execute("getAreaHtml", params);
    return params;
  }
  getAreaArr() {
    let obj = [];
    let self = this;
    self.state.areaData.forEach((ele, index) => {
      let tmp = self.getArea(ele, index);
      obj.push(tmp);
    });
    return obj;
  }
  getRefreshTime() {
    return this.state.refreshTime.toLocaleString();
  }
  render() {
    let self = this;
    let styleMain = {};
    // styleMain.border = this.defaultAreaBorder;
    styleMain.width = self.state.width;
    styleMain.height = self.state.height;
    // styleMain.display = "flex";
    let tmp = this.getAreaArr();
    if (!tmp || tmp.length == 0) {
      tmp = <div className='ListArea_NoData'>
        <div className="table-nodata">
          <SvgIcon type="nodata" />
          暂时没有数据哦~
         </div>
      </div>;
    }
    return <div style={styleMain} className={this.getClassName("ListArea")}  >
      {this.state.bNeedRefresh ? <div className={this.getClassName("ListArea_Time")}>{this.getRefreshTime()}</div> : ""}
      {tmp}
    </div >;
  }


  // InitAreaColumns(columns) {
  //   this.setState({ fieldMapping: tmp, areaColums: columns });
  // }
  refreshData() {
    let parentModel = this.gridModel.getCache("parent");
    parentModel && parentModel.execute('refresh');
  }

};
export default ListAreaMap



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/ListAreaMap.jsx